var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisteredMedicineStudentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1.87rem",
    viewBox: "0 0 45 51.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-doctor-solid",
    d: "M22.5,25.714A12.857,12.857,0,1,0,9.643,12.857,12.857,12.857,0,0,0,22.5,25.714Zm-9.643,5.545A17.914,17.914,0,0,0,0,48.445a2.984,2.984,0,0,0,2.983,2.983H42.017A2.984,2.984,0,0,0,45,48.445,17.914,17.914,0,0,0,32.143,31.259v5.1a6.435,6.435,0,0,1,4.821,6.228v4.018a1.612,1.612,0,0,1-1.607,1.607H33.75a1.607,1.607,0,1,1,0-3.214V42.589a3.214,3.214,0,0,0-6.429,0V45a1.607,1.607,0,1,1,0,3.214H25.714a1.612,1.612,0,0,1-1.607-1.607V42.589a6.435,6.435,0,0,1,4.821-6.228V30.626q-.9-.09-1.838-.09H17.91q-.934,0-1.838.09V37.2a5.625,5.625,0,1,1-3.214,0ZM14.464,45a2.411,2.411,0,1,0-2.411-2.411A2.411,2.411,0,0,0,14.464,45Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisteredMedicineStudentsIcon);
export default __webpack_public_path__ + "static/media/registered-medicine-students-icon.efec154c711709fc661c00046d04ee1a.svg";
export { ForwardRef as ReactComponent };